import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\CreateScreenController::__invoke
* @see app/Http/Controllers/Screen/CreateScreenController.php
* @route '/api/screen-settings'
*/
const CreateScreenController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateScreenController.url(options),
    method: 'post',
})

CreateScreenController.definition = {
    methods: ["post"],
    url: '/api/screen-settings',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Screen\CreateScreenController::__invoke
* @see app/Http/Controllers/Screen/CreateScreenController.php
* @route '/api/screen-settings'
*/
CreateScreenController.url = (options?: RouteQueryOptions) => {
    return CreateScreenController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\CreateScreenController::__invoke
* @see app/Http/Controllers/Screen/CreateScreenController.php
* @route '/api/screen-settings'
*/
CreateScreenController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateScreenController.url(options),
    method: 'post',
})

export default CreateScreenController